<ul class="d-flex list-group cloudlocationslist cursor-pointer rounded-0">
  <li class="list-group-item subheader cloudlocations d-flex justify-content-between align-items-center border-top-0 border-start-0 border-end-0 bg-white">
    <div class="col-9 text-truncate">
      <strong translate="CloudLocations.Name"></strong>
    </div>
    <div class="col-3">
      <strong translate="CloudLocations.Size"></strong>
    </div>
  </li>
  @for (item of items; track item) {
    <li
      (click)="onItemClick(item)"
      class="list-group-item cloudlocations d-flex justify-content-between align-items-center border-top-0 border-start-0 border-end-0"
      [ngClass]="{'cursor-pointer': item.isFolder || !isExportMode, 'selected': isFileSelected(item.id)}"
      [id]="'list_' + item.id">
      @if (!item.isFolder && !isExportMode) {
        <input
          id="checkbox_{{item.id}}"
          (click)="$event.stopPropagation()"
          [checked]="isFileSelected(item.id)"
          (change)="onCheckboxChange(item)"
          type="checkbox"
          class="me-2 checkbox_list_item">
      }
      <div class="col-9 text-truncate" [ngClass]="{'cursor-pointer': item.isFolder || !isExportMode}">
        @if (item.isFolder) {
          <i class="bi bi-folder-fill bi-large mb-1 me-2"></i>
        }
        @if (!item.isFolder) {
          <i class="bi bi-large mb-1" [class]="getFileIcon(item.name)"></i>
        }
        <span [ngClass]="{'cursor-pointer': item.isFolder || !isExportMode}">{{item.name}}</span>
      </div>
      <span class="col-3" [ngClass]="{'cursor-pointer': item.isFolder || !isExportMode}">
        {{ item.size | byteSizePipe }}
      </span>
    </li>
  }
</ul>
